import React from "react";
import i18next from "../../locale/i18n";

type ActiveTool = 'cut' | 'sew' | 'unfold' | null;

interface MobileToolbarProps {
    // Goals
    edgeSeams: number;
    seamsGoal: number | null;
    globalStretchness: number;
    stretchGoal: number | null;
    onNext: () => void;
    // Tools (landscape only)
    showTools: boolean;
    showNextButton: boolean;
    toolCutButton: React.RefObject<HTMLButtonElement>;
    toolSewButton: React.RefObject<HTMLButtonElement>;
    toolUnfoldButton: React.RefObject<HTMLButtonElement>;
    activeTool: ActiveTool;
}

export function MobileToolbar({
    edgeSeams,
    seamsGoal,
    globalStretchness,
    stretchGoal,
    onNext,
    showTools,
    showNextButton,
    toolCutButton,
    toolSewButton,
    toolUnfoldButton,
    activeTool
}: MobileToolbarProps) {
    const t = (key: string) => i18next.t(key);

    const getGoalColor = (current: number, goal: number | null): string => {
        if (goal === null) return 'inherit';
        return current <= goal ? 'var(--color-success)' : 'var(--color-error)';
    };

    const seamsMet = seamsGoal === null || edgeSeams <= seamsGoal;
    const stretchMet = stretchGoal === null || globalStretchness <= stretchGoal;
    const goalsMet = seamsMet && stretchMet;

    const getToolButtonClass = (tool: ActiveTool): string => {
        return activeTool === tool ? 'mobile-tool-btn mobile-tool-btn-active' : 'mobile-tool-btn';
    };

    return (
        <div className="mobile-toolbar">
            <div className="mobile-toolbar-goals">
                <div className="mobile-goal-item">
                    <span className="mobile-goal-label">{t('practice:seamCount')}:</span>
                    <span
                        className="mobile-goal-value"
                        style={{ color: getGoalColor(edgeSeams, seamsGoal) }}
                    >
                        {edgeSeams}/{seamsGoal ?? '—'}
                    </span>
                </div>
                <div className="mobile-goal-item">
                    <span className="mobile-goal-label">{t('practice:stretch')}:</span>
                    <span
                        className="mobile-goal-value"
                        style={{ color: getGoalColor(globalStretchness, stretchGoal) }}
                    >
                        {globalStretchness}/{stretchGoal ?? '—'}
                    </span>
                </div>
            </div>

            {showTools && (
                <div className="mobile-toolbar-tools">
                    <button
                        ref={toolCutButton}
                        className={getToolButtonClass('cut')}
                    >
                        {t('practice:cut')}
                    </button>
                    <button
                        ref={toolSewButton}
                        className={getToolButtonClass('sew')}
                    >
                        {t('practice:sew')}
                    </button>
                    <button
                        ref={toolUnfoldButton}
                        className={getToolButtonClass('unfold')}
                    >
                        {t('practice:unfold')}
                    </button>
                </div>
            )}

            {showNextButton && (
                <button
                    className={goalsMet ? "mobile-next-btn" : "mobile-next-btn mobile-next-btn-blocked"}
                    onClick={onNext}
                >
                    {t('practice:next')}
                </button>
            )}
        </div>
    );
}
